module.exports = __webpack_public_path__ + "img/booked_status.82faedd9.svg";